import { HiX } from 'react-icons/hi';
import { useBoolean } from 'usehooks-ts';

import GoogleAd from '../GoogleAd';

const InlistShop = () => {
  const { value: isVisible, setFalse: close } = useBoolean(true);

  return isVisible ? (
    <div
      aria-hidden
      tabIndex={-1}
      className="relative mx-auto mb-6 w-full h-full aspect-grid overflow-hidden rounded-lg ring-2 ring-slate-100 bg-slate-50"
    >
      <button
        className="p-1 rounded-full bg-gray-100 text-gray-400 absolute top-0 right-0 mr-1.5 mt-1.5 border border-gray-300 "
        onClick={close}
        tabIndex={-1}
      >
        <HiX size={10} />
      </button>
      <span className="py-0.5 px-2 text-3xs rounded-full bg-gray-100 text-gray-600 absolute top-0 left-0 ml-2 mt-2">
        publicité
      </span>
      <GoogleAd
        ad={{
          slot: '/118262226/C2_Web_Shop',
          mapping: {
            0: [174, 300],
            1024: [200, 350],
          },
          sizes: [
            [174, 300],
            [200, 350],
          ],
        }}
        className={'mx-auto mb-6 w-full h-full overflow-hidden rounded-lg'}
      />
    </div>
  ) : null;
};

export default InlistShop;
